import { TypedUseSelectorHook, useSelector } from 'react-redux';

import { Actions } from '../actions';
import { ActionTypes, UIState } from './types';

const initialState: UIState = {
    indicators: {
        loading: false,
        error: null,
        showModal: false
    },
    redirectUrl: null,
    modalType: null,
    modalData: null
};

const uiReducer = (state = initialState, action: Actions): UIState => {
    switch (action.type) {
        case ActionTypes.SET_MODAL: {
            return {
                ...state,
                indicators: {
                    ...state.indicators,
                    showModal: action.payload
                }
            };
        }
        case ActionTypes.TOGGLE_MODAL: {
            const { type, url = null } = action.payload;
            return {
                ...state,
                indicators: {
                    ...state.indicators,
                    showModal: type !== null ? !state.indicators.showModal : false,
                    loading: false,
                    error: null
                },
                redirectUrl: url || state.redirectUrl,
                modalType: type ?? state.modalType,
                modalData: action.payload
            };
        }
        case ActionTypes.CHANGE_MODAL: {
            const { type } = action.payload;
            return {
                ...state,
                indicators: {
                    ...state.indicators,
                    error: null,
                    loading: false
                },
                modalType: type,
                modalData: action.payload
            };
        }
        default:
            return state;
    }
};
export const name = 'ui';
export const useUIStore: TypedUseSelectorHook<UIState> = (selector, ...args) =>
    useSelector((store: any) => selector(store[name]), ...args);
export default uiReducer;
